import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.template.html',
})
export class SidenavComponent {
  @Input('items') public menuItems: any[] = [];
  @Input('hasIconMenu') public hasIconTypeMenuItem: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle: string;

  constructor() {}
  ngOnInit() {
    this.menuItems.forEach(menu => {
      menu.childs = this.menuItems.filter(x => x.ParentId == menu.Id);
    });
  }

  sortedList(arr) {
    return _.sortBy(arr, ['Index']);
  }

  GetChild(item){
    return this.menuItems.filter(x=>x.ParentId = item.Id);
  }
}
